import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  key: 0,
  class: "d-sm-flex align-items-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Image "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Nom "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Quantité "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Prix "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Statut "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
    }, "ACTIONS")
  ])
], -1)
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "badge badge-outline-danger text-outline-primary" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_19 = { class: "dropdown" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_21 = { class: "dropdown-menu" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-price-tag-1 lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_28 = { key: 2 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-flash lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 3 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-giftbox lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_36 = { key: 4 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-close-1 lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_39 = { key: 5 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-flash lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 6 }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-hot-sale lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_51 = { key: 7 }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_54 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddNewCategorieModal = _resolveComponent("AddNewCategorieModal")!
  const _component_AddPromotionModal = _resolveComponent("AddPromotionModal")!
  const _component_AddCollectionModal = _resolveComponent("AddCollectionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.checkPermission('AddProduit'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                to: "/ajouter-produit"
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createTextVNode(" Ajouter un produit ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", {
            class: "search-box position-relative me-15",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher un produit"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _hoisted_6
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (produit, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("img", {
                      src: _ctx.getUrlApiForProductFiles(produit.urlImage),
                      alt: "Image",
                      width: "50",
                      height: "50"
                    }, null, 8, _hoisted_12)
                  ]),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(produit.title.slice(0, 10)), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(produit?.depot), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(produit.price), 1),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(produit.statut ? "Actif" : "Non Actif"), 1)
                  ]),
                  _createElementVNode("td", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("ul", _hoisted_21, [
                        (_ctx.checkPermission('AddProduitCategorie'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "#",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#AddNewCategorieModal",
                                onClick: ($event: any) => (_ctx.openAddNewCategorieModal(produit))
                              }, [
                                _hoisted_24,
                                _createTextVNode(" Ajouter de (s) catégorie (s) ")
                              ], 8, _hoisted_23)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.checkPermission('AddProduitCollection'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "#",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#AddCollectionModal",
                                onClick: ($event: any) => (_ctx.openAddCollectionModal(produit))
                              }, [
                                _hoisted_27,
                                _createTextVNode(" Ajouter dans une collection ")
                              ], 8, _hoisted_26)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.checkPermission('SwitchProduit'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "#",
                                onClick: ($event: any) => (_ctx.switchProduit(produit.id))
                              }, [
                                _hoisted_30,
                                (!produit.statut)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, " Activer le produit"))
                                  : _createCommentVNode("", true),
                                (produit.statut)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, " Désactiver le produit"))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_29)
                            ]))
                          : _createCommentVNode("", true),
                        (!produit.is_sale)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                              (_ctx.checkPermission('StartProduitPromo'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "#",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#AddPromotionModal",
                                    onClick: ($event: any) => (_ctx.openAddPromotionModal(produit, produit.sale_price))
                                  }, [
                                    _hoisted_35,
                                    _createTextVNode(" Mettre en promotion ")
                                  ], 8, _hoisted_34))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (produit.is_sale)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                              (_ctx.checkPermission('EndPromotion'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "#",
                                    onClick: ($event: any) => (_ctx.confirmEndPromo(produit.id))
                                  }, [
                                    _hoisted_38,
                                    _createTextVNode(" Retirer de promotion ")
                                  ], 8, _hoisted_37))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.checkPermission('SwitchFeature'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "#",
                                onClick: ($event: any) => (_ctx.switchFeature(produit.id))
                              }, [
                                _hoisted_41,
                                (!produit.is_featured)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, " Activer feature"))
                                  : _createCommentVNode("", true),
                                (produit.is_featured)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, " Désactiver feature"))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_40)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.checkPermission('SwitchHot'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_44, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "#",
                                onClick: ($event: any) => (_ctx.switchHot(produit.id))
                              }, [
                                _hoisted_46,
                                (!produit.hot)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, " Activer hot"))
                                  : _createCommentVNode("", true),
                                (produit.hot)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, " Désactiver hot"))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_45)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            to: { name: 'EditProduitPage', params: { id: produit.id } },
                            class: "dropdown-item d-flex align-items-center"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_49,
                              _createTextVNode("Modifier")
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            to: { name: 'ViewProduitPage', params: { id: produit.id } },
                            class: "dropdown-item d-flex align-items-center"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_50,
                              _createTextVNode("Détails")
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        (_ctx.checkPermission('DeleteProduit'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.suppression(produit.id,_ctx.produits,'produits',`le produit ${produit.title}`))
                              }, [
                                _hoisted_53,
                                _createTextVNode(" Supprimer ")
                              ], 8, _hoisted_52)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddNewCategorieModal, {
      selectedProduit: _ctx.selectedProduit,
      selectedProduitId: _ctx.selectedProduitId,
      onClose: _ctx.recharger
    }, null, 8, ["selectedProduit", "selectedProduitId", "onClose"]),
    _createVNode(_component_AddPromotionModal, {
      selectedProduit: _ctx.selectedProduit,
      selectedProduitId: _ctx.selectedProduitId,
      onClose: _ctx.recharger
    }, null, 8, ["selectedProduit", "selectedProduitId", "onClose"]),
    _createVNode(_component_AddCollectionModal, {
      selectedProduit: _ctx.selectedProduit,
      selectedProduitId: _ctx.selectedProduitId,
      onClose: _ctx.recharger
    }, null, 8, ["selectedProduit", "selectedProduitId", "onClose"])
  ], 64))
}